import Button from "lib/ui/controls/Button";
export default class LightButton extends Button {
    constructor(text = "Button", type = "default") {
        super();
        if (type == "default")
            this.addClass("ctr-lightbutton-default");
        if (type == "round")
            this.addClass("ctr-lightbutton-round");
        this.addClass("ctr-lightbutton").append(text);
    }
    slim() {
        this.addClass("ctr-lightbutton-slim");
        return this;
    }
    setText(text) {
        this.text(text);
        return this;
    }
}
